<template>
  <div>
    <b-field v-if="title">
      <div class="mgl-10px has-text-weight-bold mg-auto">{{ title }} </div>
      <div v-if="!isAlreadySelect">
        <button class="button is-size-7" @click="clearSelection">
          {{ $t('selectionProduit.clearSelection') }}
        </button>
      </div>
    </b-field>
    <div v-if="info" class="has-text-centered has-text-icon-more mgt-20px">
      {{ info }}
    </div>
    <div v-for="(produit, index) in selection" :key="index">
      <div class="mgt-10px has-background-background">
        <div class="columns is-vcentered shadow is-marginless">
          <div class="panier-imgProduit column is-narrow is-paddingless is-flex">
            <img
              v-if="produit.logo"
              :src="produit.logo"
              class="panier-imgProduit-logo"/>
            <div v-else>
              <div class="panier-imgProduit-face"></div>
            </div>
          </div>
          <div class="column mgl-10px is-paddingless">
            <b-field class="mgb-0">
              <p class="has-text-link is-size-6 ellipsis has-text-weight-bold textPanier">
                {{ produit.produit.libelle }}
              </p>
              <b-icon
                v-if="isAlreadySelect"
                icon="bookmark-check"
                type="is-link"
                size="is-small"
                class="mgv-auto">
              </b-icon>
            </b-field>
            <p class="has-text-default is-size-7 ellipsis textPanier">
              {{ formatageDatePeriode(produit.dateDebut, produit.dateFin) }}
            </p>
            <p v-if="!forSelectionFaceOnly" class="has-text-default is-size-7 textPanier">
              {{ $t(getLibelleAndRoutesForProduct(produit.produit).libelle) }}
            </p>
          </div>
          <div class="column is-narrow">
            <a @click="makeDelete(index)">
              <b-icon
                icon="delete-forever"
                type='is-danger'>
              </b-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '@/services/general/formatDate';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { DELETE_LIGNE_IN_PANIER, SET_PANIER } from '@/store/modules/produitFace-mutation-type';

export default {
  props: {
    selection: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    info: {
      type: String,
      required: false,
    },
    isAlreadySelect: {
      type: Boolean,
      required: true,
    },
    storeName: {
      type: String,
      default: 'produitFace',
    },
    forSelectionFaceOnly: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectionGetter() {
      return this.$store.getters[`${this.storeName}/panier`];
    },
  },
  methods: {
    formatageDatePeriode(dateDebut, dateFin) {
      if (!dateDebut && !dateFin) return '';
      if (dateDebut === dateFin) return formatDate(dateDebut);
      return this.$t('selectionProduit.datePeriode', { dateDebut: formatDate(dateDebut), dateFin: formatDate(dateFin) });
    },
    makeDelete(index) {
      const payload = { index: index, isAlreadySelect: this.isAlreadySelect };
      this.$store.commit(`${this.storeName}/${DELETE_LIGNE_IN_PANIER}`, payload);
    },
    clearSelection() {
      const payload = this.selectionGetter.filter((produit) => produit.isAlreadySelect);
      this.$store.commit(`${this.storeName}/${SET_PANIER}`, payload);
    },
    getLibelleAndRoutesForProduct(produit) {
      const find = produitConf.CATEGORIE_PRODUIT.find((p) => {
        return p.code === produit.supportCommercial.categorieVente;
      });
      if (!find) return null;
      if (find.code !== produitConf.CATEGORIE_LOCATION) return find;
      return produit.numerique ? find.numerique : find.nonNumerique;
    },
  },
};
</script>
